module.exports = __webpack_public_path__ + "img/arrow-left-btn-mouseover.65047766.svg";